import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { RdoHttpService } from '@/app/core/http/rdo-http.service';
import { Alert } from '@/app/models/alert';
import { UserQuery } from '@/app/models/body';
import { LocaleFormat } from '@/app/models';
import { ErrorService } from '@/app/core/errors/error.service';
import { SearchService } from '@/app/header/search.service';
import { retryBeforeThrow } from '@/app/core/utils/retry-before-throw';
import { AuthForbiddenErrorService } from '@/app/core/errors/auth-forbidden-error.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class HeaderService {
  public manuallyShowCompetitionDisclaimer = false;
  public showInApplicationGuidanceSettings = false;

  constructor(
    private rdoHttp: RdoHttpService,
    private errorService: ErrorService,
    private searchService: SearchService,
    private forbiddenService: AuthForbiddenErrorService
  ) {}

  public searchProductTypes = (query: string): Observable<any> => {
    return this.searchService.searchProductTypes(query);
  };

  public searchCustomers = (query: string): Observable<any> => {
    return this.searchService.searchCustomers(query);
  };

  public searchSalesReps = (query: string): Observable<any> => {
    return this.searchService.searchSalesReps(query);
  };

  public searchAssets = (query: string): Observable<any> => {
    return this.searchService.searchAssets(query);
  };

  public getAlerts = (userId: number): Observable<Array<Alert>> => {
    const url = 'alerts';
    const body = new UserQuery();
    body.UserId = userId;
    return this.rdoHttp.post(url, body).pipe(map((res) => res as Array<Alert>));
  };

  public setCompetitionDisclaimerAcceptance = (): Observable<any> => {
    const url = `identity/competitionDisclaimer`;
    return this.rdoHttp.post(url).pipe(
      map((res) => res),
      catchError((err) => {
        this.errorService.logSentryError(
          err,
          'header.service:setCompetitionDisclaimerAcceptance failed:'
        );
        return throwError(err);
      })
    );
  };

  public getLocaleFormats = (): Observable<Array<LocaleFormat>> => {
    let result: Observable<Array<LocaleFormat>> = null;

    result = this.rdoHttp
      .clone()
      .disableRoutingAbort()
      .get('/filter/locale-formats')
      .pipe(
        retryBeforeThrow({ label: 'HeaderService.getLocaleFormats' }),
        map((r) => r as Array<LocaleFormat>),

        catchError((err) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 403) {
              this.forbiddenService.handleError(err);
              return throwError(err); // TODO: Maybe we shouldn't rethrow here?
            }
          }
          this.errorService.logSentryError(
            err,
            'HeaderService.getLocaleFormats failed:'
          );
          return throwError(err);
        })
      );

    return result;
  };

  public updateAlert = (alert: any): Observable<object> => {
    const url = 'alerts';

    return this.rdoHttp.put(url, alert);
  };
}
